window.soldsieCartData = function() {
  try {
    var result = {};

    if (!window.soldsieCartData.caller || 
        !window.soldsieCartData.caller.arguments || 
        window.soldsieCartData.caller.arguments.length == 0 || 
        !window.soldsieCartData.caller.arguments[0].cart_data
      )
      return result;

    var cartData = window.soldsieCartData.caller.arguments[0].cart_data; 

    var product = window.MonogramHelper.findProductByVariant(cartData.id);

    if (!product)
      return result;

    result["properties[builder_id]"] = "shapp_options_" + product.id + "_" + (new Date().getTime());
    result["properties[master_builder]"] = "1";
    result["properties[Add a Monogram]"] = "No Thanks";       

    return result;
  }
  catch (e) {
    return {};
  }
}